import React from 'react';

import Hero from '../../components/Hero';

const Title = () => (
  <>
    Automate. Be&nbsp;
    <br className="xl:hidden" />
    <span className="text-gray-50">more productive</span>
  </>
);

const IndexHero = () => {
  return (
    <Hero
      title={<Title />}
      button1={{
        text: 'Explore Google Add-ons',
        title: 'Explore Google Workspace Add-ons',
        href: '#products',
      }}
      button2={{
        text: 'Meet the Developer',
        title: 'Meet the Google Developer Expert',
        href: 'https://www.labnol.org/about',
      }}
    >
      Supercharge your productivity and efficiency with our Google Workspace
      Add-ons for Gmail, Google Sheets, Forms and Google Drive.
    </Hero>
  );
};

export default IndexHero;
